import driveTrafficDemo from "@/assets/drive-traffic-demo.png";
import optimizeStoreDemo from "@/assets/optimize-store-demo.png";
import runOperationsDemo from "@/assets/run-operations-demo.png";
import { Button } from "@/components/ui/button";
const PlatformSection = () => {
  return <section className="w-full py-16 md:py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-normal">
            Your All-in-One AI<br />
            Platform for Ecommerce.
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Accelerate growth with AI that collaborate, automate, and think alongside your team.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {/* Drive Traffic */}
          <div className="bg-white rounded-2xl p-8 lg:p-10 space-y-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden">
            <div className="space-y-4">
              <h3 className="text-2xl sm:text-3xl font-semibold text-gray-900">
                Generate Traffic
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Generate ads, copy, and campaigns that drive sales.
              </p>
            </div>
            <div className="-mx-4 -mb-4 lg:-mx-6 lg:-mb-6">
              <img src={driveTrafficDemo} alt="Traffic analytics dashboard" loading="lazy" decoding="async" className="w-full h-auto scale-110 origin-top" />
            </div>
          </div>

          {/* Optimize Store */}
          <div className="bg-white rounded-2xl p-8 lg:p-10 space-y-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden">
            <div className="space-y-4">
              <h3 className="text-2xl sm:text-3xl font-semibold text-gray-900">
                Convert Visitors
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Create product pages that boost conversion.
              </p>
            </div>
            <div className="-mx-4 -mb-4 lg:-mx-6 lg:-mb-6">
              <img src={optimizeStoreDemo} alt="Store optimization interface" loading="lazy" decoding="async" className="w-full h-auto scale-110 origin-top" />
            </div>
          </div>

          {/* Run Operations */}
          <div className="bg-white rounded-2xl p-8 lg:p-10 space-y-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden">
            <div className="space-y-4">
              <h3 className="text-2xl sm:text-3xl font-semibold text-gray-900">
                Optimize Operations
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Optimize daily workflows to maximize your business profit.
              </p>
            </div>
            <div className="-mx-4 -mb-4 lg:-mx-6 lg:-mb-6">
              <img src={runOperationsDemo} alt="Operations dashboard" loading="lazy" decoding="async" className="w-full h-auto scale-110 origin-top" />
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg">
            Get Started
          </Button>
          <Button size="lg" variant="outline">
            Learn More
          </Button>
        </div>
      </div>
    </section>;
};
export default PlatformSection;